// removed by extract-text-webpack-plugin
module.exports = {"banner":"banner_banner_3ww9W","bannerInfo":"banner_bannerInfo_2IIaC","orange":"banner_orange_8SlkC","body":"banner_body_3BZUR body"};


//////////////////
// WEBPACK FOOTER
// ./src/static/solution/banner/banner.css
// module id = 254
// module chunks = 4